import { render, staticRenderFns } from "./NutritionalAwareness.vue?vue&type=template&id=6d31e743&scoped=true"
import script from "./NutritionalAwareness.vue?vue&type=script&lang=js"
export * from "./NutritionalAwareness.vue?vue&type=script&lang=js"
import style0 from "./NutritionalAwareness.vue?vue&type=style&index=0&id=6d31e743&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d31e743",
  null
  
)

export default component.exports